<div class="modal-header main-modal-header">
    <button type="button" class="close" aria-hidden="true" (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">{{label}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="main-box">
                <div class="main-box-body">
                    <div style="padding-top: 20px;max-height: 500px;overflow-y: scroll" class="pb-5">
                        <div *ngIf="!resumeProcessedActivity || resumeProcessedActivity != 'NotProcessed'">
                            <div class="col-xs-4" *ngFor="let candidate of candidates">
                                <app-candidate-card *ngIf="candidatesLoadedFlag" [candidateInfo]="candidate" [userId]="userId" candidateType="OWN_CANDIDATES"
                                    [filterParams]="candidatesQueryFilter" [activityMap]="activityMap" [jobMatchesPopoverPosition]="candidate.uploadResumePopoverPosition"></app-candidate-card>
                            </div>
                        </div>

                        <div class="col-xs-12" *ngIf="resumeProcessedActivity === 'NotProcessed'">
                            <div class="col-xs-12">
                                <div class="pull-right">
                                    <button class="btn btn-primary" (click)="downloadAllResumes()">Download All</button>
                                </div>
                            </div>
                            <h4 class="mt-0">List of Non Processed Candidates</h4>
                            <div *ngFor="let candidate of candidates" class="main-box py-3 px-4">
                                <h4 class="mt-0 mb-3 non-processed-heading text-primary font-bold">{{candidate.name}}</h4>
                                <div class="col-xs-12 pl-0">
                                    <div class="col-xs-6 pl-0">
                                        <p class="non-processed-table-content mb-2"><span class="font-bold">Resume file name: </span>
                                            <span>{{candidate.failedFileName}}</span>
                                        </p>
                                    </div>
                                    <div class="col-xs-6">
                                        <p class="non-processed-table-content mb-2"><span class="font-bold">Reason for failure: </span>
                                            <span class="text-danger">{{candidate.failureReason}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row border-bottom">
                                    <div class="col-xs-12">
                                        <div class="row py-2">
                                            <div class="col-xs-2 non-processed-table-heading">
                                                First Name
                                            </div>
                                            <div class="col-xs-2 non-processed-table-heading">
                                                Last Name
                                            </div>
                                            <div class="col-xs-3 non-processed-table-heading">
                                                Phone Number
                                            </div>
                                            <div class="col-xs-3 non-processed-table-heading">
                                                Email
                                            </div>
                                            <div class="col-xs-2 non-processed-table-heading">
                                                Score
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="row pt-3">
                                            <div class="col-xs-2 non-processed-table-content">
                                                {{candidate.firstName}}
                                            </div>
                                            <div class="col-xs-2 non-processed-table-content">
                                                {{candidate.lastName}}
                                            </div>
                                            <div class="col-xs-3 non-processed-table-content">
                                                {{candidate.phone}}
                                            </div>
                                            <div class="col-xs-3 non-processed-table-content">
                                                {{candidate.email}}
                                            </div>
                                            <div class="col-xs-2 non-processed-table-content">
                                                {{candidate.score}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
